export default __webpack_public_path__ + "static/1340-adf7e5e3cb089d993543c70843c4a03d.gif";